"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import Link from "next/link";
import Image from "next/image";
import HallaSheriLogo from "../../../public/hallasheri.png";
import useSettingStore from "@/store/settings.store";
import { Switch } from "./switch";
import { Moon, Sun } from "lucide-react";

function Navbar({
  userName,
  fullName,
  profileUrl,
}: {
  userName: string;
  fullName: string;
  profileUrl: string | undefined;
}) {
  const { theme, setTheme } = useSettingStore();
  return (
    <div className="sticky left-0 right-0 top-0 z-50 bg-white/20 px-2 py-2 shadow backdrop-blur dark:bg-neutral-900/20">
      <main className="flex w-full items-center justify-between md:container">
        {/* Website Logo */}
        <div className="flex select-none items-center gap-1">
          <Link href="/" className="w-fit">
            <Image
              src={HallaSheriLogo}
              alt="SunValor"
              className="w-12 rounded-full bg-clip-text"
            />
          </Link>
        </div>
        <div className="flex flex-row items-center justify-between gap-4 px-5">
          <div className="flex flex-row-reverse items-center gap-3 md:flex md:flex-row">
            <Avatar className="rounded-xl">
              <AvatarImage
                src={profileUrl}
                className="object-cover"
                alt="ProfileAvatar"
              />
              <AvatarFallback className="select-none bg-neutral-100 text-black dark:bg-neutral-800 dark:text-white"></AvatarFallback>
            </Avatar>
            <div className="flex flex-col justify-center gap-1">
              <p className="text-end text-sm text-black dark:text-white md:text-start">
                {fullName}
              </p>
              <Badge
                variant="secondary"
                className="rounded-2xl bg-neutral-200 py-0 text-[11px] text-neutral-700 hover:bg-neutral-300 dark:bg-neutral-800 dark:text-neutral-300 dark:hover:bg-neutral-700"
              >
                {decodeURIComponent(userName)}
              </Badge>
            </div>
          </div>
          <Switch
            aria-label="Toggle dark mode"
            className="dark:data-[state=checked]:bg-brand-900 scale-125 data-[state=checked]:bg-neutral-800 data-[state=unchecked]:bg-yellow-400 dark:data-[state=unchecked]:bg-neutral-800"
            checked={theme}
            onCheckedChange={(checked) => setTheme(checked)}
            thumbChildren={
              theme ? (
                <Moon size={12} className="fill-violet-200 text-violet-200" />
              ) : (
                <Sun size={12} className="fill-orange-500 text-yellow-600" />
              )
            }
            thumbClassName="flex items-center justify-center data-[state=checked]:bg-neutral-100 data-[state=unchecked]:bg-neutral-100 dark:data-[state=checked]:bg-neutral-950 dark:data-[state=unchecked]:bg-neutral-950"
          />
        </div>
      </main>
    </div>
  );
}

export default Navbar;
